
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ComparisonHero from './components/ComparisonHero';
import ProblemSolution from './components/ProblemSolution';
import CostComparison from './components/CostComparison';
import ValueProposition from './components/ValueProposition';
import RiskAnalysis from './components/RiskAnalysis';
import CTASection from './components/CTASection';

export default function Comparison() {
  useEffect(() => {
    // Add Schema.org JSON‑LD for Service comparison
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Dinari Designs vs In-House Employee Cost Comparison',
      description:
        'Comprehensive cost and value analysis comparing contracting Dinari Designs for construction detailing versus hiring an in-house employee in Vancouver BC.',
      url: `${import.meta.env.VITE_SITE_URL || window.location.origin}/comparison`,
      mainEntity: {
        '@type': 'Service',
        name: 'Construction Detailing Services',
        provider: {
          '@type': 'LocalBusiness',
          name: 'Dinari Designs',
        },
      },
    });

    // Append script safely – guard against duplicate insertion
    if (!document.head.querySelector('script[data-schema="comparison"]')) {
      script.setAttribute('data-schema', 'comparison');
      document.head.appendChild(script);
    }

    // Cleanup on unmount
    return () => {
      const schemaScript = document.head.querySelector(
        'script[data-schema="comparison"]'
      );
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <ComparisonHero />
      <ProblemSolution />
      <CostComparison />
      <ValueProposition />
      <RiskAnalysis />
      <CTASection />
      <Footer />
    </div>
  );
}
